<template>
    <div class="reservation-view position-relative">
        <div class="containter">
            <div class="row mb-3">
                <div class="col-md-9">
                    <h1 class="page-title">
                        <SidebarButton :dashboardUrl="dashboardUrl" />
                        Nova reserva
                    </h1>
                </div>
            </div>
        </div>
        <div class="calendar-loading" v-if="loading">
            <i class="material-icons loading-icon-size">cached</i>
        </div>

        <ReservationForm
            v-if="newReservation"
            :products="availableProducts"
            :reservation="newReservation"
            :on-cancel="cancelNewReservation"
            :on-submit="handleReservationSubmit"
            :show-form-title="false"
        ></ReservationForm>
    </div>
</template>

<script>
import { requestJson, requestAllPagesJson } from "../helpers";
import ReservationForm from "./ReservationForm.vue";
import RequestCount from "./mixins/RequestCount";
import SidebarButton from "./SidebarButton";

export default {
    mixins: [RequestCount],
    components: {
        ReservationForm,
        SidebarButton,
    },
    props: {
        availableProductsUrl: String,
        storeReservationUrl: String,
        dashboardUrl: String,
    },
    data() {
        return {
            availableProducts: [],
            newReservation: {
                data: { schedule_time_minutes: "" },
                validation: null,
            },
        };
    },
    methods: {
        async requestAvailableProducts() {
            this.addRequestCount();
            try {
                this.availableProducts = await requestAllPagesJson(
                    this.availableProductsUrl
                );
            } finally {
                this.subRequestCount();
            }
        },
        cancelNewReservation() {
            this.newReservation = null;
            this.handleNavigation("/reservations-beta");
        },
        handleReservationSubmit(formData) {
            this.addRequestCount();
            this.newReservation = { ...this.newReservation, data: formData };
            requestJson(this.storeReservationUrl, formData, "POST")
                .then((json) => this.receiveReservationResponse(json, formData))
                .catch((ex) => null);
        },
        receiveReservationResponse(json, formData) {
            this.subRequestCount();

            if (json.status === "OK") {
                this.newReservation = null;

                const param = this.getParam(formData);
                let url = "/reservations-beta/calendar";

                if (param) {
                    url += `?${param}`;
                }

                this.handleNavigation(url);
            } else {
                this.newReservation = {
                    ...this.newReservation,
                    validation: json.errors,
                };
            }
        },
        handleNavigation(url) {
            window.parent.postMessage(
                {
                    event_id: "navigate",
                    data: {
                        url,
                    },
                },
                this.dashboardUrl
            );
        },
        getParam(formData) {
            if (!formData.schedule_date) {
                return null;
            }

            const params = new URLSearchParams();

            const [year, month, day] = formData.schedule_date.split("-");

            params.set("year", year);
            params.set("month", month);
            params.set("date", `${year}-${month}-${day}`);

            return params.toString();
        },
    },
    async mounted() {
        await this.requestAvailableProducts();
    },
};
</script>
